import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal, Stack } from 'react-bootstrap';
import { Button, Icon, useDimension } from 'lb-components';
import {
  BalanceIcon,
  PlusIcon,
  MinusIcon,
  BackspaceIcon,
} from '../../../../assets/icons';

import classes from './GameDepositModal.module.scss';
import { useTranslation } from 'lb-store';
import classNames from 'classnames';
import { UseUser } from 'lb-store/src/hooks';

const GameDepositModal = ({ onSuccess, onCancel, balance, ...props }) => {
  const inputRef = useRef();
  const User = UseUser();
  const [amount, setAmount] = useState(User?.User?.balance?.balance || 0);
  const [lastAction, setLastAction] = useState();
  //const [showInput, setShowInput] = useState(false);
  const { t } = useTranslation();
  const { clientWidth, clientHeight } = useDimension();
  const ratio = useMemo(() => {
    return clientWidth / clientHeight;
  }, [clientWidth, clientHeight]);

  const intervalRef = useRef();

  const hotMoney = (m) => {
    if (m > 100000) m = 100000;

    if (m < 10) return [2, 5, 10];

    const r = Math.pow(10, parseInt(m).toString().length - 1);
    const n = Math.trunc(m / r) * r;
    const arr = [0.2, 0.5, 1];
    const res = [];

    for (let el of arr) {
      let amount = Math.round(el * n);
      res.push(amount);
    }
    return res;
  };

  const callback = (error) => {
    console.log(error);
  };
  const numpadHandler = (input) => {
    //setShowInput(false);

      //console.log(input)

    if (
      (input === '.' && amount.includes('.')) ||
      amount.split('.')[1]?.length === 2
    ) {
      setLastAction(null);
      //newVal= amount.substr(0, amount.length - 1).concat(input);
      setAmount(input);
      return;
    }
    let newVal;
    if (amount === '0') newVal = input === '.' ? '0.' : input;
    else {
      newVal = amount.concat(input);
    }

    const parsed = parseFloat(newVal) || 0;
    if (parsed < 0) setAmount('0');
    else if (parsed > balance) setAmount(balance.toString());
    else if (newVal.split('.')[1]?.length > 2) setAmount(parsed.toFixed(2));

    else setAmount(newVal);

    setLastAction(null);
  };
  const quickActionHandler = (input) => {
    //setShowInput(false);

    setAmount((prevState) => {
      let amount = parseFloat(prevState) || 0;
      let newVal;
      //handle +-1
      if (Math.abs(input) === 1) {
        newVal = amount + input;
        setLastAction(null);
      } else if (lastAction === input) {
        newVal = amount + input;
      } else {
        newVal = input;
        setLastAction(input);
      }

      newVal = newVal < 0 ? 0 : newVal;
      newVal = newVal > balance ? balance : newVal;

      return newVal.toFixed(2);
    });
  };

  const limitHandler = (amount) => {
    const parsed = parseFloat(amount) || 0;
    if (parsed < 0) setAmount('0');
    else if (parsed > balance) setAmount(balance.toString());
    else if (amount.split('.')[1]?.length > 2) setAmount(parsed.toFixed(2));
    else setAmount(amount);

    setLastAction(null);
  };

  /*useEffect(() => {
    if (showInput) {
      inputRef.current.focus();
    }
  }, [showInput]);*/

  return (
    <Modal
      show
      centered
      contentClassName={classNames({
        [classes.modal]: true,
        [classes.horizontal]: ratio >= 0.8,
      })}
      dialogClassName={classes.wrapper}
      onHide={onCancel}
    >
      <Modal.Header
        className={classes.header}
        closeButton
        closeVariant={'white'}
      />
      <Modal.Body
        className={classes.body}
        style={{ flexDirection: ratio < 0.8 ? 'column' : 'row' }}
      >
        <div style={{ margin: '0.7rem' }}>
          <div className={classes.balanceContainer}>
            <div>
              <label>{t('ძირითადი ანგარიში')}</label>
              <span>
                {balance}
                <sup style={{ fontSize: '2.2rem' }}>₾</sup>
              </span>
            </div>
            <Button variant={'success'} style={{ padding: '1rem 1.2rem' }}>
              <Icon
                Icon={BalanceIcon}
                style={{
                  height: '2.5rem',
                  width: '2.5rem',
                }}
              />
            </Button>
          </div>
          <span
            style={{
              fontFamily: 'lbet-st',
              textAlign: 'center',
              color: '#fff',
              fontSize: '1.7rem',
            }}
          >
            {t('გადასარიცხი თანხა')}
          </span>
          <div className={classes.amountContainer}>
            <Button
              variant={'secondary'}
              onPointerDown={(e) => {
                quickActionHandler(-1);
                intervalRef.current = setInterval(() => {
                  quickActionHandler(-1);
                }, 300);
              }}
              onPointerUp={(e) => {
                clearInterval(intervalRef.current);
              }}
              onPointerOut={(e) => {
                clearInterval(intervalRef.current);
              }}
            >
              <Icon Icon={MinusIcon} type={'vec'} />
            </Button>
            {/*{showInput ? (
              <input
                ref={inputRef}
                value={parseFloat(amount) ? parseFloat(amount) : ''}
                type={'number'}
                onChange={(e) => limitHandler(e.target.value)}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontFamily: ' lbet-st',
                  fontSize: '2.8rem',
                  lineHeight: '2.8rem',
                  width: '100%',
                  border: 0,
                  outline: 0,
                  textAlign: 'center',
                  margin: 0,
                  padding: 0,
                }}
                onFocus={(e) => e.target.select()}
              />
            ) : (
              <span onClick={() => setShowInput(true)}>{amount}</span>
            )}*/}
            <input
              ref={inputRef}
              value={amount}
              type={'text'}
              onChange={(e) => limitHandler(e.target.value)}
              inputMode='decimal'
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: ' lbet-st',
                fontSize: '2.8rem',
                lineHeight: '2.8rem',
                width: '100%',
                border: 0,
                outline: 0,
                textAlign: 'center',
                margin: 0,
                padding: 0,
              }}
              onFocus={(e) => e.target.select()}
            />
            <Button
              variant={'secondary'}
              onPointerDown={(e) => {
                quickActionHandler(1);
                intervalRef.current = setInterval(() => {
                  quickActionHandler(1);
                }, 300);
              }}
              onPointerUp={(e) => {
                clearInterval(intervalRef.current);
              }}
              onPointerOut={(e) => {
                clearInterval(intervalRef.current);
              }}
            >
              <Icon Icon={PlusIcon} type={'vec'} />
            </Button>
          </div>
          <input
            type={'range'}
            min={0.0}
            max={balance}
            step={0.01}
            value={parseFloat(amount) || 0}
            onChange={(e) => {
              setLastAction(null);
              setAmount((parseFloat(e.target.value) || 0).toFixed(2));
            }}
            style={{
              margin: '2.4rem 0',
              backgroundSize: `${((parseFloat(amount) || 0) * 100) / balance}% 100%`,
            }}
          />
          <Button
            variant={'success'}
            style={{
              padding: '1.1rem',
              fontSize: '2.4rem',
              marginBottom: '1rem',
              fontFamily: 'lbet-st',
            }}
            onClick={() =>
              onSuccess({
                amount: parseFloat(amount) || 0,
                callback: callback,
                onCancel: onCancel,
              })
            }
          >
            {t('გადარიცხვა')}
          </Button>
        </div>
        <div style={{ backgroundColor: '#33363F', padding: '1.3rem' }}>
          <div className={classes.quickActions}>
            {hotMoney(balance).map((val) => (
              <Button
                key={val}
                variant={'secondary'}
                onClick={() => quickActionHandler(val)}
                data-current={lastAction === val ? '+' : ''}
              >
                {val} ₾
              </Button>
            ))}
            <Button
              variant={'secondary'}
              onClick={() => {
                setAmount(balance.toString());
                setLastAction(null);
              }}
            >
              ALL
            </Button>
          </div>
          <div className={classes.numpad}>
            {new Array(9).fill(0).map((_i, index) => (
              <Button
                key={index}
                variant={'secondary'}
                onClick={() => numpadHandler((index + 1).toString())}
              >
                {index + 1}
              </Button>
            ))}
            <Button variant={'secondary'} onClick={() => numpadHandler('.')}>
              .
            </Button>
            <Button variant={'secondary'} onClick={() => numpadHandler('0')}>
              0
            </Button>
            <Button
              variant={'secondary'}
              onClick={() => {
                /*const formattedVal = (amount.length > 1 && amount[amount.length - 1]) === '.' ? amount : parseFloat(amount).toString() || ''
                setAmount(formattedVal.length > 1 ? formattedVal.slice(0, -1) : '0');
                setLastAction(null);*/
                setAmount(amount.length > 1 ? amount.slice(0, -1) : '0');
                setLastAction(null);
              }}
            >
              <Icon
                Icon={BackspaceIcon}
                type={'vec'}
                style={{
                  height: '3.5rem',
                  width: '3.5rem',
                  backgroundColor: '#fff',
                  margin: '0 auto',
                }}
              />
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GameDepositModal;
